
<div *ngIf="maint == false">


<ngx-loading-bar></ngx-loading-bar>
<router-outlet></router-outlet>
<app-editprofile></app-editprofile>
<app-tap-to-top></app-tap-to-top>
<!-- <app-layout-box></app-layout-box> -->
 </div>


  
<div class="maintenance-container" *ngIf="maint === true">
  <h1 class="maintenance-title">{{ showdetails.name }}</h1>

  <img [src]="imgerror" alt="Maintenance Banner" class="maintenance-image" />

  <p class="maintenance-desc">{{ showdetails?.parsedName?.desc }}</p>
</div>